import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export var ProjectAvatar = function (_a) {
    var author = _a.author;
    var initials = author.charAt(0);
    return (_jsx(React.Fragment, { children: _jsx("div", { className: "post-avatar-col", children: _jsx("div", { className: "post-avatar", children: initials }) }) }));
};
